/* Primary */
export const BitPay = '#1A3B8B';
export const Action = '#2240C4';
export const Black = '#000000';
export const Feather = '#F6F7FC';
export const LightBlack = '#252525';
export const Slate = '#9BA3AE';
export const SlateDark = '#434D5A';
export const White = '#FFFFFF';
export const Error = '#C52A42';
export const NeutralSlate = '#F5F7F8';
export const Slate30 = '#E1E4E7';
export const LinkBlue = '#4989FF';
export const Warning = '#FDB455';
